// src/components/AppointmentModelButton.jsx
import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";
import Modal from "react-modal";

// Set the app element for accessibility (modify '#root' if your app root is different)
Modal.setAppElement("#root");

const AppointmentModelButton = ({ heading, text, buttonText }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleOpenModal = () => {
    setModalIsOpen(true);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
  };

  return (
    <section
      className="section-parallax-3 section"
      id="call-to-action-section"
    >
      <Fade
        direction="up"
        cascade={true}
        damping={0.5}
        delay={400}
        triggerOnce
      >
        <div className="container">
          <h3>{heading}</h3>
          <p>{text}</p>
          {buttonText && (
            <button onClick={handleOpenModal} className="btn">
              {buttonText}
            </button>
          )}
        </div>
      </Fade>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Book an Appointment"
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            height: "80%",
            zIndex: "1000",
          },
        }}
      >
        <button onClick={handleCloseModal} style={{ float: "right" }}>
          Close
        </button>
        <h2>Book an Appointment</h2>
        <iframe
        src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3ftI5c-7safYh7WKHERrFgZeosBRVJZk1ctSkxmK1xIxDIojmOVKAsf7X9rDpSGxFziYApfyaN?gv=true"
        style={{ border: '0', background: '#ebe7e0', padding: '1em', borderRadius: '1em' }}
        width="100%"
        height="80%"
        frameBorder="0"
        scrolling="yes"
        title="Schedule a Meeting with Murtaza Lightwala"
      ></iframe>
      </Modal>
    </section>
  );
	// return (
    
	// 	<section
	// 		className={`section-parallax-3 section}`}
	// 		id="call-to-action-section"
	// 	>
            
	// 		<Fade direction="up" cascade={true} damping={0.5} delay={400} triggerOnce>
	// 			<div className="container">
	// 				<h3>{heading}</h3>
	// 				<p>{text}</p>
	// 				{buttonText && scriptLoaded && (
  //           // eslint-disable-next-line
	// 					<a
  //           onClick={handleClick}
  //           className="btn"
	// 					>
	// 						{buttonText}
	// 					</a>
	// 				)}
	// 			</div>
	// 		</Fade>
	// 	</section>
	// );
};

export default AppointmentModelButton;
